var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"viewer"}},[_c('b-container',[_c('h4',[_vm._v("Visor de contrato")]),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"pdfV"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfb92aca","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contractView/contractViewer.vue
// module id = 526
// module chunks = 0